export default "__VITE_ASSET__tpLaua6F__"